import { create } from 'zustand'
import { TestModel } from "../stories/TestModel";

interface CUDState<T> {
    add: (e: T) => boolean
    remove: (id: string) => boolean
    update: (e: T) => boolean
}
interface StepState extends CUDState<TestModel> {
    list: TestModel[];
    set: (a: TestModel[]) => void

}
export const useStepSignStore = create<StepState>((set) => ({
    list: [],
    add: (e) => {

        let exists = false;
        set((state) => {
            exists = state.list.some(item => item.id === e.id);
            if (!exists) {
                return { list: [...state.list, e] };
            } else {
                return { list: state.list };
            }
        });
        return !exists;
    },
    remove: (id) => {
        set((state) => {
            if (!state.list.some(item => item.id === id)) {
                return state; // No change if item does not exist
            }
            return { list: state.list.filter(item => item.id !== id) };
        });
        return true;
    },
    update: (e) => {
        set((state) => {
            if (!state.list.some(item => item.id === e.id)) {
                return state; // No change if item does not exist
            }
            return {
                list: state.list.map(item => (item.id === e.id ? e : item))
            };
        });
        return true;
    },
    set: (e) => {
        set((state) => ({ list: e }));
    },
}));